import { render } from "./popup-issue-information.vue?vue&type=template&id=2b2b42f2&ts=true"
import script from "./popup-issue-information.vue?vue&type=script&lang=ts"
export * from "./popup-issue-information.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__